// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file patients/get_patient.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Patient } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetPatientRequest
 */
export class GetPatientRequest extends Message<GetPatientRequest> {
  /**
   * Unique identifier for the patient
   *
   * @generated from field: string patient_id = 1;
   */
  patientId = "";

  constructor(data?: PartialMessage<GetPatientRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetPatientRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "patient_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPatientRequest {
    return new GetPatientRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPatientRequest {
    return new GetPatientRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPatientRequest {
    return new GetPatientRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPatientRequest | PlainMessage<GetPatientRequest> | undefined, b: GetPatientRequest | PlainMessage<GetPatientRequest> | undefined): boolean {
    return proto3.util.equals(GetPatientRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetPatientResponse
 */
export class GetPatientResponse extends Message<GetPatientResponse> {
  /**
   * Details of the patient
   *
   * @generated from field: com.neulink.pharmacy.Patient patient = 1;
   */
  patient?: Patient;

  constructor(data?: PartialMessage<GetPatientResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetPatientResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "patient", kind: "message", T: Patient },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPatientResponse {
    return new GetPatientResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPatientResponse {
    return new GetPatientResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPatientResponse {
    return new GetPatientResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPatientResponse | PlainMessage<GetPatientResponse> | undefined, b: GetPatientResponse | PlainMessage<GetPatientResponse> | undefined): boolean {
    return proto3.util.equals(GetPatientResponse, a, b);
  }
}

